import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0ccab3cc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=0ccab3cc&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=0ccab3cc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccab3cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ccab3cc')) {
      api.createRecord('0ccab3cc', component.options)
    } else {
      api.reload('0ccab3cc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0ccab3cc&scoped=true", function () {
      api.rerender('0ccab3cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/imgUploadView/index.vue"
export default component.exports